module.exports = __webpack_public_path__ + "static/media/Snapshot Vid_1728925953313.a1edcdf2. Script 09 2024";